import { None, Some } from "../option";
export class Ok {
    constructor(v) {
        this.value = v;
    }
    map(fn) {
        return new Ok(fn(this.value));
    }
    mapErr(fn) {
        return new Ok(this.value);
    }
    isOk() {
        return true;
    }
    isErr() {
        return false;
    }
    ok() {
        return new Some(this.value);
    }
    err() {
        return None.instance();
    }
    and(res) {
        return res;
    }
    andThen(op) {
        return op(this.value);
    }
    or(res) {
        return this;
    }
    orElse(op) {
        return new Ok(this.value);
    }
    unwrapOr(optb) {
        return this.value;
    }
    unwrapOrElse(op) {
        return this.value;
    }
    unwrap() {
        return this.value;
    }
    toString() {
        return "Some " + this.value;
    }
}
export class Err {
    constructor(error) {
        this.error = error;
    }
    map(fn) {
        return new Err(this.error);
    }
    mapErr(fn) {
        return new Err(fn(this.error));
    }
    isOk() {
        return false;
    }
    isErr() {
        return false;
    }
    ok() {
        return None.instance();
    }
    err() {
        return new Some(this.error);
    }
    and(res) {
        return new Err(this.error);
    }
    andThen(op) {
        return new Err(this.error);
    }
    or(res) {
        return res;
    }
    orElse(op) {
        return op(this.error);
    }
    unwrapOr(optb) {
        return optb;
    }
    unwrapOrElse(op) {
        return op(this.error);
    }
    unwrap() {
        throw "Err.get";
    }
    toString() {
        return "None";
    }
}
